import { EnvConfig } from './types'

export const devConfig: EnvConfig = {
  isDev: true,
  isProd: false,
  isTest: false,
}
